let colorArrDefault = ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"];
let colorArrUED = ['#0A9DB2', '#8E10E0', '#125EEB', '#C18D36', '#FA8787', '#9BE9D2', '#FFCB51', '#FF9450', '#FDEF89', '#9FC5FF', '#1C9DB6', '#FFBDB4', '#54C0D0', '#9577D2', '#C5B0F4', '#4E68B2', '#C7ADBA', '#E8DDCB', '#9AB6A1', '#D2B689', '#A2738C'];
let colorArrAntd = ['#ff4d4f', '#ff7a45', '#ffa940', '#ffc53d', '#ffec3d', '#bae637', '#73d13d', '#36cfc9', '#40a9ff', '#597ef7', '#9254de', '#f759ab'];
let colorArrDelete = ['#FDEF89'];
let colorArr = colorArrDefault; // 切换不同的颜色组
colorArr = colorArr.filter(_ => !colorArrDelete.includes(_));
colorArr.sort(() => { return Math.random() > .5 ? -1 : 1;});

let colorUtil = {
    opacityTo: (colorStr, opacity = .75) => {
        let color = tinycolor(colorStr);
        let colorObj = color.toRgb();
        colorObj.a = opacity;
        color = tinycolor(colorObj);
        return color.toRgbString();
    },
    lightnessTo: (colorStr, lightness = .75) => {
        let color = tinycolor(colorStr);
        let colorObj = color.toHsl();
        let newLightness = colorObj.l * lightness
        colorObj.l = newLightness > 1 ? 1 : newLightness;
        color = tinycolor(colorObj);
        return color.toHexString();
    },
    colorAlpha: str => isNaN(str) ? tinycolor(str).getAlpha(): 1,
    colorStr2Hex: str => isNaN(str) ? parseInt(tinycolor(str).toHex(), 16) : str,
    randomColor: Math.round(Math.random() * Math.pow(2, 24)),
};

// 模块导出
window.colorUtil = colorUtil;
let exportObj = {
    colorUtil,
    colorArr
};
export default exportObj;
export {
    colorUtil,
    colorArr
}
